import { KeyboardArrowDownIcon } from "src/Pages/components/Icons/Icons";

type IIconExpand = {
  IsOpen: boolean;
};

export const IconExpandIsOpen = ({ IsOpen }: IIconExpand) => {
  return (
    <KeyboardArrowDownIcon
      sx={{
        color: "#9b9b9b",
        width: "22px",
        transition: "transform 0.3s ease-out 0s",
        transform: IsOpen ? "rotate(360deg)" : "rotate(270deg)",
      }}
    />
  );
};
